(() => {
  'use strict';

  if (window.__sinLipomasReleasitLegacyV1) return;
  window.__sinLipomasReleasitLegacyV1 = true;

  const config = window.SinLipomasReleasitLegacyConfig;
  if (!config || window.location.pathname !== '/products/sinlipomas') return;

  const OFFER_COUNTS = [2, 4, 6];
  const IMAGE_URLS = [config.images.two, config.images.four, config.images.six];
  const OFFER_COPY = [
    {
      title: 'RECIBE 2 SINLIPOMAS',
      plaque: 'OFERTA 2×1',
      detail: 'PAGAS 1 Y RECIBES 2',
    },
    {
      title: 'RECIBE 4 SINLIPOMAS',
      plaque: '20% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $12.780',
    },
    {
      title: 'RECIBE 6 SINLIPOMAS',
      plaque: '45% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $28.755',
    },
  ];
  const HEADING = '1 - Elige cuántos SinLipomas quieres recibir 👇';
  const SESSION_KEY = 'sinlipomas_releasit_offer_deadline_v1';
  const DURATION_MS = 10 * 60 * 1000;
  let timerHandle = null;
  let memoryDeadline = null;

  const getDeadline = () => {
    if (memoryDeadline) return memoryDeadline;
    try {
      const stored = Number(window.sessionStorage.getItem(SESSION_KEY));
      if (Number.isFinite(stored) && stored > 0) {
        memoryDeadline = stored;
        return stored;
      }
      memoryDeadline = Date.now() + DURATION_MS;
      window.sessionStorage.setItem(SESSION_KEY, String(memoryDeadline));
      return memoryDeadline;
    } catch (_) {
      memoryDeadline = Date.now() + DURATION_MS;
      return memoryDeadline;
    }
  };

  const setOfferImage = (image, url, count) => {
    if (!image || !url) return;
    if (image.dataset.slOfferImage !== String(count)) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url;
      image.alt = `Recibes ${count} SinLipomas`;
      image.dataset.slOfferImage = String(count);
    }
  };

  const selectedOfferIndex = (modal) => {
    const offers = [...modal.querySelectorAll('._rsi-quantity-offers-offer-container')];
    const index = offers.findIndex((offer) => offer.classList.contains('_rsi-quantity-offers-selected'));
    return index >= 0 ? index : 0;
  };

  const updateSummaryImage = (modal) => {
    const summaryImage = [...modal.querySelectorAll('img._rsi-modal-line-item-image')]
      .find((image) => !image.closest('._rsi-quantity-offers-offer-container'));
    const index = selectedOfferIndex(modal);
    setOfferImage(summaryImage, IMAGE_URLS[index], OFFER_COUNTS[index]);
  };

  const renderTimer = (timer) => {
    const clock = timer.querySelector('[data-sl-releasit-clock]');
    if (!clock) return;
    const remaining = Math.max(0, getDeadline() - Date.now());
    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    clock.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    timer.dataset.expired = remaining <= 0 ? 'true' : 'false';
    if (remaining <= 0 && timerHandle) {
      window.clearInterval(timerHandle);
      timerHandle = null;
    }
  };

  const ensureTimer = (modal, offersBlock) => {
    let timer = modal.querySelector('[data-sl-releasit-timer]');
    if (!timer) {
      timer = document.createElement('div');
      timer.className = 'sl-releasit-offer-timer';
      timer.dataset.slReleasitTimer = 'true';
      timer.setAttribute('role', 'timer');
      timer.setAttribute('aria-label', 'La oferta finaliza en diez minutos');
      timer.innerHTML = '<span aria-hidden="true">⏰</span><span>La oferta finaliza en <strong data-sl-releasit-clock>10:00</strong> minutos</span>';
      offersBlock.parentNode.insertBefore(timer, offersBlock);
    }
    renderTimer(timer);
    if (!timerHandle && timer.dataset.expired !== 'true') {
      timerHandle = window.setInterval(() => renderTimer(timer), 1000);
    }
  };

  const ensureBaseSaving = (modal, offersBlock) => {
    let saving = modal.querySelector('[data-sl-releasit-base-saving]');
    if (!saving) {
      saving = document.createElement('div');
      saving.className = 'sl-releasit-base-saving';
      saving.dataset.slReleasitBaseSaving = 'true';
      saving.innerHTML = '<span aria-hidden="true">✓</span><span>Todas las opciones ya incluyen <strong>35% DE DESCUENTO</strong></span>';
      offersBlock.parentNode.insertBefore(saving, offersBlock);
    }
  };

  const applyOfferCopy = (offer, copy) => {
    if (!offer || !copy) return;
    const title = offer.querySelector('._rsi-quantity-offers-title');
    const plaque = offer.querySelector('._rsi-quantity-offers-plaque');
    if (!title || !plaque) return;

    title.textContent = copy.title;
    title.dataset.slOfferCopy = 'true';
    plaque.textContent = copy.plaque;
    plaque.dataset.slOfferCopy = 'true';

    let detail = offer.querySelector('[data-sl-releasit-offer-detail]');
    if (!detail) {
      detail = document.createElement('div');
      detail.className = 'sl-releasit-offer-detail';
      detail.dataset.slReleasitOfferDetail = 'true';
      plaque.insertAdjacentElement('afterend', detail);
    }
    detail.textContent = copy.detail;
  };

  const enhanceModal = (modal) => {
    if (!modal) return;

    const offerContainers = [...modal.querySelectorAll('._rsi-quantity-offers-offer-container')];
    const offersBlock = modal.querySelector('._rsi-quantity-offers');
    if (!offersBlock || offerContainers.length < 3) return;
    modal.dataset.slEnhanced = 'true';

    const heading = [...modal.querySelectorAll('._rsi-custom-text-field')]
      .find((node) => /^1\s*-\s*Elige\b/i.test(node.textContent.trim()));
    if (heading && heading.textContent.trim() !== HEADING) {
      heading.textContent = HEADING;
      heading.dataset.slOfferHeading = 'true';
    }

    offerContainers.slice(0, 3).forEach((offer, index) => {
      setOfferImage(offer.querySelector('img._rsi-modal-line-item-image'), IMAGE_URLS[index], OFFER_COUNTS[index]);
      applyOfferCopy(offer, OFFER_COPY[index]);
    });

    ensureTimer(modal, offersBlock);
    ensureBaseSaving(modal, offersBlock);
    updateSummaryImage(modal);

    if (!modal.dataset.slOfferObserverReady) {
      const observer = new MutationObserver(() => updateSummaryImage(modal));
      offerContainers.slice(0, 3).forEach((offer) => observer.observe(offer, { attributes: true, attributeFilter: ['class'] }));
      modal.dataset.slOfferObserverReady = 'true';
    }
  };

  let hydrationTimer = 0;
  const scheduleEnhancement = () => {
    const modal = document.querySelector('#_rsi-cod-form-modal');
    if (!modal || modal.dataset.slEnhanced === 'true' || hydrationTimer) return;
    hydrationTimer = window.setTimeout(() => {
      hydrationTimer = 0;
      const currentModal = document.querySelector('#_rsi-cod-form-modal');
      if (!currentModal || currentModal.dataset.slEnhanced === 'true') return;
      enhanceModal(currentModal);
      if (currentModal.dataset.slEnhanced === 'true') documentObserver.disconnect();
      else scheduleEnhancement();
    }, 500);
  };

  const isModalMutation = (mutation) => {
    const target = mutation.target?.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target?.parentElement;
    if (target?.closest?.('#_rsi-cod-form-modal')) return true;
    return [...mutation.addedNodes].some((node) =>
      node.nodeType === Node.ELEMENT_NODE &&
      (node.id === '_rsi-cod-form-modal' || node.querySelector?.('#_rsi-cod-form-modal'))
    );
  };

  const documentObserver = new MutationObserver((mutations) => {
    if (mutations.some(isModalMutation)) scheduleEnhancement();
  });
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });
  scheduleEnhancement();
})();
